import { createSlice } from "@reduxjs/toolkit";
import { APP_CONSTANTS } from "../../../core/config/appConstants";
const initialState = {
	result: null
};

const verificationActionSlice = createSlice({
	name: APP_CONSTANTS.STORAGE_CONSTANTS.SCENARIO_DECLINE,
	initialState,
	reducers: {
		setParams: (state, action) => {
			state.result = action.payload.result;
		}
	}
});

export const { setParams } = verificationActionSlice.actions;
export default verificationActionSlice.reducer;
